import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import { useTransparentProps } from 'header-utils/context/TransparentPropsContext/useTransparentProps'
import { IconHamburger } from 'icons/components/IconHamburger'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useMenus } from 'menu/hooks/useMenus'
import { useState } from 'react'
import { OutletBrand, ShopBrand } from 'types/brands'
import { CommonGenericEvents } from '../../constants/analytics/analytics'

import styles from './HamburgerButton.module.css'

type HamburgerButtonProps = {
	readonly handleOpenMenu: () => void
}
export const HamburgerButton = ({ handleOpenMenu }: HamburgerButtonProps) => {
	const { brandSelected, updateBrandSelected } = useMenus()
	const { t } = useLabels()
	const { isShop } = useMasterData()
	const [ariaControls, setAriaControls] = useState<string | undefined>(
		undefined
	)
	const { iconColor } = useTransparentProps()

	const defaultBrand = isShop ? ShopBrand.she : OutletBrand.outlet
	const brandToOpen = brandSelected ?? defaultBrand

	const handleButtonClick = () => {
		updateBrandSelected(brandToOpen)
		sendGenericEvent(CommonGenericEvents.ClickHeader, {
			section: 'menu',
		})
		setAriaControls('StructureSM')
		handleOpenMenu()
	}

	return (
		<button
			type='button'
			data-testid='menu.burger'
			aria-label={t('accessibility.header.menu.icon')}
			aria-controls={ariaControls}
			onClick={handleButtonClick}
			className={styles.button}
		>
			<IconHamburger color={iconColor} className={styles.menuIcon} />
		</button>
	)
}
